import * as React from "react";
import { useContext } from "react";
import StreamsContext from "contexts/StreamsContext";
const StreamTitle = ({ id, children }) => {
  var _a;
  const streams = useContext(StreamsContext);
  const stream = streams == null ? void 0 : streams.find((candidate) => candidate.id === id);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = stream == null ? void 0 : stream.title) != null ? _a : children);
};
export default StreamTitle;
